function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CapitalOneInverted = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#clip0_8328_1461)",
    children: [/*#__PURE__*/_jsx("mask", {
      id: "mask0_8328_1461",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "0",
      width: "40",
      height: "40",
      children: /*#__PURE__*/_jsx("path", {
        d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#mask0_8328_1461)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M-55.9526 18.4456C-55.2236 18.3145 -54.4681 18.1821 -53.6886 18.0489C-44.5409 16.3201 -45.8692 14.8893 -11.3515 10.8385C10.826 7.94451 33.3537 8.26185 36.1946 14.5195C40.6231 24.2741 0.345875 45.828 -21.1674 56.5438C8.09639 38.0776 21.5326 26.9733 17.1147 19.918C10.7599 9.76921 -31.3537 14.2308 -53.6886 18.0489C-54.3772 18.179 -55.1254 18.3108 -55.9526 18.4456Z",
        fill: "white"
      })
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "clip0_8328_1461",
      children: /*#__PURE__*/_jsx("rect", {
        width: "40",
        height: "40",
        fill: "white"
      })
    })
  })]
}));
CapitalOneInverted.displayName = 'CapitalOneInverted';
//# sourceMappingURL=CapitalOneInverted.js.map